import axios from "axios";
const API_URL =
  process.env.VUE_APP_SORRY_URL_FR ||
  "https://api.sorryapp.com/v1/pages/8a17b9d2";

export default () => {
  return axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
};
